import ReactRailsUJS from 'react_ujs';

let componentsContext = {};

const RegisterComponentsContext = (components) => {
  components.forEach((component) => {
    componentsContext[component.displayName] = component;
  })
};

ReactRailsUJS.getConstructor = (name) => {
  return componentsContext[name]
}

const setupTurboEventListeners = () => {
  ReactRailsUJS.handleEvent('turbo:load', ReactRailsUJS.handleMount, false);
  ReactRailsUJS.handleEvent('turbo:frame-load', ReactRailsUJS.handleMount, false);
  ReactRailsUJS.handleEvent('turbo:before-render', ReactRailsUJS.handleUnmount, false);

  // Unregister the setup function itself to ensure it runs only once
  document.removeEventListener('turbo:load', setupTurboEventListeners);
};

document.addEventListener('turbo:load', setupTurboEventListeners);

export default RegisterComponentsContext;